import React from 'react'
import {
  SectionPaper,
  SubSectionTitle,
  SectionTitle,
  SubSectionWrapper,
} from 'components/startup/startup-styles'
import { Column } from 'components/common/layout'
import { TextViewer } from 'components/common/text-editor'
import { checkEditorDefaultValue } from 'utils/validations'

export const CompensationWelfare: React.FC<{
  compensation: string
  welfare: string
}> = ({ compensation, welfare }) => {
  const hasNotCompensation =
    !compensation || checkEditorDefaultValue(compensation)
  const hasNotWelfare = !welfare || checkEditorDefaultValue(welfare)
  if (hasNotCompensation && hasNotWelfare) return null
  return (
    <Column id='benefit'>
      <SectionTitle>보상 및 복지</SectionTitle>
      <Column style={{ gap: 32 }}>
        {!hasNotCompensation && (
          <SubSectionWrapper>
            <SubSectionTitle>Q. 얻을 수 있는 보상이 있나요?</SubSectionTitle>
            <SectionPaper>
              <TextViewer value={compensation} />
            </SectionPaper>
          </SubSectionWrapper>
        )}
        {!hasNotWelfare && (
          <SubSectionWrapper>
            <SubSectionTitle>Q. 복지가 궁금해요</SubSectionTitle>
            <SectionPaper>
              <TextViewer value={welfare} />
            </SectionPaper>
          </SubSectionWrapper>
        )}
      </Column>
    </Column>
  )
}
